import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { GetDailyPageViewSummaryDto, FetchError } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

type Params = {
  startDateUtc?: string;
  endDateUtc?: string;
};

const useGetDailyPageViewSummaryRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getDailyPageViewSummaryRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.analytics.getDailyPageViewSummary>>): Promise<GetDailyPageViewSummaryDto> {
    const accessToken = await getAccessToken();
    const [{ startDateUtc, endDateUtc }] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/analytics/daily-page-view-summary`);
    if (startDateUtc !== undefined) url.searchParams.set("startDateUtc", startDateUtc);
    if (endDateUtc !== undefined) url.searchParams.set("endDateUtc", endDateUtc);

    const response = await fetch(url.toString(), {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getDailyPageViewSummaryRequest };
};

const useGetDailyPageViewSummary = (params?: Params) => {
  const { getDailyPageViewSummaryRequest } = useGetDailyPageViewSummaryRequest();

  return useQuery({
    queryKey: queryKeys.analytics.getDailyPageViewSummary(params),
    queryFn: getDailyPageViewSummaryRequest,
  });
};

export { useGetDailyPageViewSummary };
